import { Link } from "react-router";

/** "Terms of Use · Privacy Policy" links, shown wherever the disclaimer appears. */
export function LegalLinks() {
  return (
    <span className="legal-links">
      <Link to="/terms" className="link">
        Terms of Use
      </Link>
      <span aria-hidden>·</span>
      <Link to="/privacy" className="link">
        Privacy Policy
      </Link>
    </span>
  );
}
